export const AllPettyPurchasesReducer = (state = [], action) => {
  switch (action.type) {
    case "GET_ALL_PETTY_PURCHASES_REQUEST":
      return {
        loading: true,
      };
    case "GET_ALL_PETTY_PURCHASES_SUCCESS":
      return {
        ...state,
        loading: false,
        purchases: action.payload.pettyPurchases,
        purchaseCount: action.payload.pettyPurchasesCount,
      };
    case "GET_ALL_PETTY_PURCHASES_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export const CurrentUserPettyPurchasesReducer = (state = [], action) => {
  switch (action.type) {
    case "GET_CURRENT_USER_PETTY_PURCHASES_REQUEST":
      return {
        loading: true,
      };
    case "GET_CURRENT_USER_PETTY_PURCHASES_SUCCESS":
      return {
        ...state,
        loading: false,
        purchases: action.payload.pettyPurchases,
        purchaseCount: action.payload.pettyPurchasesCount,
      };
    case "GET_CURRENT_USER_PETTY_PURCHASES_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export const CreatePettyPurchaseReducer = (
  state = { purchase: {} },
  action
) => {
  switch (action.type) {
    case "CREATE_PETTY_PURCHASE_REQUEST":
      return {
        loading: true,
        error: null,
        success: false,
      };
    case "CREATE_PETTY_PURCHASE_SUCCESS":
      return {
        loading: false,
        success: action.payload.success,
        requisition: action.payload,
      };
    case "CREATE_PETTY_PURCHASE_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "CREATE_PETTY_PURCHASE_RESET":
      return {
        ...state,
        success: false,
      };

    case "CLEAR_ERRORS":
      return {
        error: null,
      };
    default:
      return state;
  }
};

export const PettyPurchaseDetailsReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_PETTY_PURCHASE_DETAIL_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "GET_PETTY_PURCHASE_DETAIL_SUCCESS":
      return {
        ...state,
        loading: false,
        success: action.payload.success,
        purchase: action.payload,
      };
    case "GET_PETTY_PURCHASE_DETAIL_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export const PettyPurchaseDeleteReducer = (state = [], action) => {
  switch (action.type) {
    case "DELETE_PETTY_PURCHASE_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "DELETE_PETTY_PURCHASE_SUCCESS":
      return {
        ...state,
        loading: false,
        deleted: action.payload,
      };
    case "DELETE_PETTY_PURCHASE_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "DELETE_PETTY_PURCHASE_RESET":
      return {
        ...state,
        deleted: {},
      };

    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

export const UpdatePettyPurchaseStatusReducer = (state = {}, action) => {
  switch (action.type) {
    case "UPDATE_PETTY_PURCHASE_STATUS_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "UPDATE_PETTY_PURCHASE_STATUS_SUCCESS":
      return {
        ...state,
        loading: false,
        success: action.payload.success,
        updated: action.payload,
      };
    case "UPDATE_PETTY_PURCHASE_STATUS_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "UPDATE_PETTY_PURCHASE_STATUS_RESET":
      return {
        ...state,
        success: false,
        updated: {},
      };
    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

export const SendPettyPurchaseCommentReducer = (state = {}, action) => {
  switch (action.type) {
    case "SEND_PETTY_PURCHASE_COMMENT_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "SEND_PETTY_PURCHASE_COMMENT_SUCCESS":
      return {
        ...state,
        loading: false,
        success: action.payload.success,
        comment: action.payload,
      };
    case "SEND_PETTY_PURCHASE_COMMENT_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "SEND_PETTY_PURCHASE_COMMENT_RESET":
      return {
        ...state,
        success: false,
        comment: {},
      };
    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};
